'use client';

import { ReactFlowProvider } from 'reactflow';

export default function SkillsTreeLayout({ children }) {
  return <ReactFlowProvider>{children}</ReactFlowProvider>;
}
